import React, { useEffect, useState } from "react";
import RankService from "../../services/rank.service";
import { Button } from "react-bootstrap";
import CommonService from "../../services/common.service";
import RankCardModalDownload from "../Rank/RankCardModalDownload";

const RankingDownloads = (props) => {
  const [rankData, setRankData] = useState([]);
  const [topTenRank, setTopTenRank] = useState([]);
  const [roundListing, setRoundListing] = useState([]);
  const [roundNumber, setRoundNumber] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [gameInfoBlockData, setGameInfoBlockData] = useState({});
  useEffect(() => {
    if (props.showRankingTab) {
      CommonService.getRoundListing().then((res) => {
        if (res.success) {
          setRoundListing(res.data);
        }
      });
    }
  }, [props.showRankingTab]);

  const handleDownloadClick = (item) => {
    setRoundNumber(item?.round);
    RankService.getRank(item?.id).then((res) => {
      if (res.success) {
        setIsLoading(false);
        setRankData(res.data?.user_teams);
        setTopTenRank(res.data?.topTenRank);
      }
    });
    setShowRankModal(true);
  };
  const handleDownloadOverallRank = (item) => {
    setRoundNumber(item?.round);
    RankService.getRank().then((res) => {
      if (res.success) {
        setIsLoading(false);
        setRankData(res.data?.user_teams);
        setTopTenRank(res.data?.topTenRank);
        setGameInfoBlockData(res.gameInfoBlockData);
      }
    });
    setShowRankModal(true);
  };

  const [showRankModal, setShowRankModal] = useState(false);
  const [rankModalDetails, setRankModalDetails] = useState([]);

  const handleRankModalClose = () => setShowRankModal(false);

  const handleRankModalShow = () => {
    RankService.topTenRank().then((res) => {
      if (res.success) {
        setRankModalDetails(res.data);
        setGameInfoBlockData(res.gameInfoBlockData);
      }
    });
    setShowRankModal(true);
  };

  return (
    <>
      <div className="customscroll rankcustomscroll">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th>Type</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Overall</td>
              <td style={{ textAlign: "center" }}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => handleDownloadOverallRank()}
                >
                  Download
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="customscroll rankcustomscroll pt-2">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th>Round</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {roundListing.map((item, index) => (
              <tr key={index}>
                <td>{item.round}</td>
                <td style={{ textAlign: "center" }}>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownloadClick(item)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <RankCardModalDownload
        showRankModal={showRankModal}
        handleRankModalClose={handleRankModalClose}
        handleRankModalShow={handleRankModalShow}
        rankModalDetails={rankModalDetails}
        topTenRank={topTenRank}
        gameInfoBlockData={gameInfoBlockData}
        roundNumber={roundNumber}
      />
    </>
  );
};

export default RankingDownloads;
